module.exports = __webpack_public_path__ + "e33b74fe9a851457cf9ed89a2c8e3370.pdf";